import { useCallback } from 'react';

import {
  createAdditionalCharge,
  deleteAdditionalCharge,
  updateAdditionalCharge,
} from '../api';
import { AdditionalChargeRequest } from '../interfaces/types';

type ActionType = 'create' | 'update' | 'delete';

export default function useActions(props: {
  onSuccess: (action: ActionType) => void;
  onError: (action: ActionType, message?: string) => void;
}) {
  const { onSuccess, onError } = props;

  const createAction = useCallback(
    async (data: AdditionalChargeRequest) => {
      const result = await createAdditionalCharge(data);
      if (!result.error) {
        return onSuccess('create');
      }
      onError('create');
    },
    [onSuccess, onError],
  );

  const updateAction = useCallback(
    async (id: number, data: AdditionalChargeRequest) => {
      const result = await updateAdditionalCharge(id, data);
      if (!result.error) {
        return onSuccess('update');
      }
      onError('update');
    },
    [onSuccess, onError],
  );

  const deleteAction = useCallback(
    async (id: number) => {
      const result = await deleteAdditionalCharge(id);
      if (!result.error) {
        return onSuccess('delete');
      }
      onError('delete');
    },
    [onSuccess, onError],
  );

  return {
    create: createAction,
    update: updateAction,
    destroy: deleteAction,
  };
}
